<template>
  <keep-alive>
    <router-view></router-view>
  </keep-alive>
  <Sidebar />
</template>

<script>
// import Header from "./components/header.vue";
import Sidebar from "@/components/sidebar.vue";
// import { isMobile } from 'mobile-device-detect';

export default {
  name: "App",
  components: { Sidebar },
};
</script>
